export default "__VITE_ASSET__6b8f649f__"